import React, { useEffect, useState } from 'react';
import '../assets/splashScreen.css';

interface SplashScreenProps {
  onFinish: () => void;
}

const SplashScreen: React.FC<SplashScreenProps> = ({ onFinish }) => {
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    // Start fade out animation after 3.5 seconds to allow for full animation sequence
    const timer = setTimeout(() => {
      setFadeOut(true);
    }, 3500);

    // Complete splash screen after 4.3 seconds (800ms for fade out animation)
    const finishTimer = setTimeout(() => {
      onFinish();
    }, 4300);

    return () => {
      clearTimeout(timer);
      clearTimeout(finishTimer);
    };
  }, [onFinish]);

  return (
    <div className={`splash-screen ${fadeOut ? 'fade-out' : ''}`}>
      <div className="splash-content">
        <img 
          src={require('../assets/images/bitlens-logo.svg').default} 
          alt="BitLens Logo" 
          className="splash-logo"
        />
        <div className="splash-text-container">
          <h1 className="splash-title">BitLens Solutions</h1>
          <div className="splash-tagline">
            <span className="splash-letter">A</span>
            <span className="splash-letter">N</span>
            <span className="splash-letter">A</span>
            <span className="splash-letter">L</span>
            <span className="splash-letter">Y</span>
            <span className="splash-letter">Z</span>
            <span className="splash-letter">I</span>
            <span className="splash-letter">N</span>
            <span className="splash-letter">G</span>
            <span className="splash-letter">&nbsp;</span>
            <span className="splash-letter">T</span>
            <span className="splash-letter">O</span>
            <span className="splash-letter">M</span>
            <span className="splash-letter">O</span>
            <span className="splash-letter">R</span>
            <span className="splash-letter">R</span>
            <span className="splash-letter">O</span>
            <span className="splash-letter">W</span>
          </div>
        </div>
      </div>
      <div className="splash-loader">
        <div className="splash-loader-bar"></div>
      </div>
    </div>
  );
};

export default SplashScreen;
